import { AxiosInstance } from "axios";
import { Winner } from "../models/winner";

const WINNERS_API_PREFIX = "/draws/winners";

export const getPreviousWinners = async (
	http: AxiosInstance
): Promise<Winner[]> => {
	const body = await http.get<Winner[]>(
		`${WINNERS_API_PREFIX}/previous-winners`
	);
	return (body.data || []) as Winner[];
};
